module.exports = "/images/vendor/jquery-ui-dist/ui-icons_444444_256x240.png?d10bc07005bb2d604f4905183690ac04";